module.exports = __webpack_public_path__ + "img/ic_signup_question.2d5888a0.svg";